/**
 * The few icons of the history page (and of the card of a failed translation) that the self-hosted icon font does not carry yet
 * (`lib/icones-police.ts`): drawn here as inline SVG, 24 px box, 2 px round strokes,
 * `currentColor`. Adding them to the font would be the other way (see
 * `scripts/subset-icons.py`); this keeps the batch inside its own files.
 */
export const ICONES_HISTORIQUE = [
  'search',
  'filter_list',
  'expand_more',
  'check_box',
  'check_box_outline_blank',
  'refresh',
  // #11: "voir le résultat" in the choice of the noyaux.
  'arrow_forward',
  // #11: the three dots of the actions of a card.
  'more_vert',
  // #24: "Traduire vers un autre noyau" on the result (two arrows turning in a loop).
  'sync',
] as const;
export type NomIconeHistorique = (typeof ICONES_HISTORIQUE)[number];

interface IconeHistoriqueProps {
  name: NomIconeHistorique;
  /** Size in pixels; 20 when omitted. */
  size?: number;
  className?: string;
}

function traits(name: NomIconeHistorique) {
  switch (name) {
    case 'search':
      return (
        <>
          <circle cx="10.5" cy="10.5" r="5.5" />
          <path d="m15 15 5 5" />
        </>
      );
    case 'filter_list':
      return <path d="M4 7h16M7 12h10M10 17h4" />;
    case 'expand_more':
      return <path d="m7 10 5 5 5-5" />;
    case 'check_box':
      return (
        <>
          <rect x="4" y="4" width="16" height="16" rx="2.5" />
          <path d="m8 12.5 3 3 5-6" />
        </>
      );
    case 'check_box_outline_blank':
      return <rect x="4" y="4" width="16" height="16" rx="2.5" />;
    case 'more_vert':
      return (
        <>
          <circle cx="12" cy="5" r="1" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
        </>
      );
    case 'arrow_forward':
      return <path d="M5 12h14M13 6l6 6-6 6" />;
    case 'sync':
      return (
        <>
          <path d="M4.5 11a7.5 7.5 0 0 1 13-3.5" />
          <path d="M18 3.5v4h-4" />
          <path d="M19.5 13a7.5 7.5 0 0 1-13 3.5" />
          <path d="M6 20.5v-4h4" />
        </>
      );
    case 'refresh':
      return (
        <>
          <path d="M19.5 12a7.5 7.5 0 1 1-1-3.75" />
          <path d="M19 4v4.5h-4.5" />
        </>
      );
  }
}

/** Decorative icon: the label belongs to the control that holds it. */
export function IconeHistorique({ name, size = 20, className }: IconeHistoriqueProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      data-icone={name}
    >
      {traits(name)}
    </svg>
  );
}
